// Content cleaning and transformation utilities

// Strip contribution metadata from story content for clean display/PDF
export const cleanContributionContent = (content) => {
  if (!content) return '';
  return content
    .replace(/^\[Contributed by [^\]]+\]\n?/, '')
    .replace(/^Prompt: "[^"]*"\n?/, '')
    .replace(/^Date: [^\n]*\n?/, '')
    .replace(/^CelebrationBook: [^\n]*\n?/, '')
    .replace(/^\n+/, '')
    .replace(/\n\n\[Photo: [^\]]*\]$/, '');
};

// Convert prompt-question titles to chapter-style titles for PDF rendering
// "What's a meal that takes you back to childhood?" → "A Childhood Meal"
// Non-question titles pass through unchanged
export const promptToChapterTitle = (title) => {
  if (!title || !title.includes('?')) return title;
  let t = title.replace(/\?+$/, '').trim();
  t = t.replace(/^(What(?:'s| is| are| was| were)|Who(?:'s| is| was)|How (?:did|do|does|was|were)|When (?:did|do|does|was|were)|Where (?:did|do|does|was|were)|Why (?:did|do|does|was|were)|Do you|Did you|Can you|Could you|Tell (?:us|me) about|Tell (?:us|me)|Share|Describe)\s+/i, '');
  t = t.replace(/^(a |an |the )/i, '');
  t = t.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  if (t.split(' ').length <= 4 && !/^(My|Our|The|His|Her|Their|Its)\b/i.test(t)) {
    t = 'A ' + t.charAt(0).toLowerCase() + t.slice(1);
    t = t.charAt(0).toUpperCase() + t.slice(1);
  }
  return t || title;
};

// Safe JSON parse from localStorage with fallback
export const safeParseLS = (key, fallback) => {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch { return fallback; }
};
